module.exports = __webpack_public_path__ + "img/1528906549.52978ebb.jpg";